import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//学生信息相关API

const studentAdultEducation = {
    info: {
        queryList: config => createAPI('/baseInfoAdultEducation/student/queryList', 'post', config),

        item: config => createAPI('/baseInfoAdultEducation/student/item', 'post', config),

        save: config => createAPI('/baseInfoAdultEducation/student/save', 'post', config),

        status: config => createAPI('/baseInfoAdultEducation/student/status', 'post', config),

        importStu: config => createAPI('/baseInfoAdultEducation/student/importStu', 'post', config),

        exportStu: config => createAPI('/baseInfoAdultEducation/student/exportStu', 'post', config),

        uploadStuPhotoPackage: config => createAPI('/baseInfoAdultEducation/student/uploadStuPhotoPackage', 'post', config),

        uploadPhoto: config => createAPI('/baseInfoAdultEducation/student/uploadPhoto', 'post', config),

        delPhoto: config => createAPI('/baseInfoAdultEducation/student/delPhoto', 'post', config),

        downloadPhoto: config => createAPI('/baseInfoAdultEducation/student/downloadPhoto', 'post', config),

        supplementInfo: config => createAPI('/baseInfoAdultEducation/student/supplementInfo', 'post', config),

        yearDeptOption: config => createAPI('/baseInfoAdultEducation/student/yearDeptOption', 'post', config),

        majorOption: config => createAPI('/baseInfoAdultEducation/student/majorOption', 'post', config),

        classOption: config => createAPI('/baseInfoAdultEducation/student/classOption', 'post', config),

        exportInternalStu: config => createAPI('/baseInfoAdultEducation/student/exportInternalStu', 'post', config),

        queryAtSchoolStuList: config => createAPI('/baseInfoAdultEducation/student/queryAtSchoolStuList', 'post', config),

        exportAtSchoolStu: config => createAPI('/baseInfoAdultEducation/student/exportAtSchoolStu', 'post', config),

        loadClassCombo: config => createAPI('/baseInfoAdultEducation/student/loadClassCombo', 'post', config),

        queryStuChangeInfoList: config => createAPI('/baseInfoAdultEducation/student/queryStuChangeInfoList', 'post', config),
    },
    status: {
        initCombo: config => createAPI('/studentAdultEducation/status/initCombo', 'post', config),

        list: config => createAPI('/studentAdultEducation/status/list', 'post', config),

        loadClassComboByMajor: config => createAPI('/studentAdultEducation/status/loadClassComboByMajor', 'post', config),

        save: config => createAPI('/studentAdultEducation/status/save', 'post', config),

        submit: config => createAPI('/studentAdultEducation/status/submit', 'post', config),

        updateAuditState: config => createAPI('/studentAdultEducation/status/updateAuditState', 'post', config),

        del: config => createAPI('/studentAdultEducation/status/del', 'post', config),

        export: config => createAPI('/studentAdultEducation/status/export', 'post', config),

        verifyStuScore: config => createAPI('/studentAdultEducation/status/verifyStuScore', 'post', config),

        queryAuditFlow: config => createAPI('/studentAdultEducation/status/queryAuditFlow', 'post', config),
    },
};

export default studentAdultEducation;



// WEBPACK FOOTER //
// ./src/api/modules/studentAdultEducation.js